import * as React from 'react';
import {
    SprayApplicationRate,
    SprayEntityIds,
    SprayEventApplicationType,
    SprayEventOperations,
    SprayEventOperatorsIndex,
    SprayProduct
} from 'services/sprayEvents/types';
import { isMultiOperatorApplicationType } from 'services/sprayEvents/utils';
import ProductDetails from '../ProductDetails';
import MultipleApplicatorsTab from '../../../MultipleOperatorsTab';

interface Props {
    tabActiveIndex?: number;
    applicationType: SprayEventApplicationType;
    product: SprayProduct;
    orderIntoTank: number;
    entityIds: SprayEntityIds;
    applicationRate: SprayApplicationRate;
    sprayEventOperations: SprayEventOperations;
}

export default function ProductDetailsWrapper(
    props: Props
): React.ReactElement {
    const {
        tabActiveIndex,
        applicationType,
        product,
        orderIntoTank: selectedRow,
        entityIds,
        applicationRate,
        sprayEventOperations
    } = props;

    const getProductDetailsElement = (sprayEquipmentSetId: number) => {
        return (
            <ProductDetails
                product={product}
                productId={product.id}
                orderIntoTank={selectedRow}
                entityIds={entityIds}
                applicationRate={applicationRate}
                equipmentSetId={sprayEquipmentSetId}
            />
        );
    };
    if (isMultiOperatorApplicationType(applicationType)) {
        return (
            <MultipleApplicatorsTab
                tabActiveIndex={tabActiveIndex}
                childForOutsideRowTab={getProductDetailsElement(
                    sprayEventOperations[SprayEventOperatorsIndex.OUTSIDE]
                        .sprayEquipmentSetId
                )}
                childForDoubleRowTab={getProductDetailsElement(
                    sprayEventOperations[SprayEventOperatorsIndex.DOUBLE]
                        .sprayEquipmentSetId
                )}
            />
        );
    }

    return getProductDetailsElement(
        sprayEventOperations[SprayEventOperatorsIndex.STANDARD]
            ?.sprayEquipmentSetId
    );
}

ProductDetailsWrapper.defaultProps = {
    tabActiveIndex: 0
};
